<template>
  <div class="card">
    <div class="card-header">Sectoral PE Ratio</div>
    <pulse-loader
      v-if="loadingTable"
      class="mt-5 text-center"
    ></pulse-loader>
    <div v-else>
      <GChart type="LineChart" :data="piChartData" :options="piChartOptions" />
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    GChart,
    PulseLoader
  },
  data: function () {
    return {
      piChartData: [["Sector", "PE Ratio"]],
      piChartOptions: {
        chart: {
          title: "Sectoral PE Ratio",
          subtitle: "PE Ratio of all sectors",
        },
      },
      fetchedData: null,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
          loadingTable : 1
    };
  },
  methods: {
    loadGraphData() {
      Vue.axios.get(this.base_url + "/api/pe-ratio?timestamp=" + new Date().getTime()).then((response) => {
        this.fetchedData = response.data.data;
        this.pushDataToArray();
        this.loadingTable = 0
      });
    },
    pushDataToArray() {
      for (var key in this.fetchedData) {
        if (Object.prototype.hasOwnProperty.call(this.fetchedData, key)) {
          var val = this.fetchedData[key];
          var tempArray = [];
          tempArray.push(key);
          tempArray.push(val);
          this.piChartData.push(tempArray);
          tempArray = [];
        }
      }
    },
  },
  mounted() {
    this.loadGraphData();
  },
};
</script>

<style></style>
